import { useCallback } from 'react';
import useCookie from '~/shared/hooks/useCookie';

const TWO_MINUTES = 120000;

const useLoginError = () => {
  const [error, setCookie, resetError] = useCookie('loginError', '');
  const setError = useCallback(
    (value: string) => setCookie(value, { expires: getExpireDate() }),
    [setCookie],
  );
  return { error, setError, resetError };
};

const getExpireDate = () => new Date(Date.now() + TWO_MINUTES);

export default useLoginError;
